import type { StatusAlimento } from "../types";

/** Codificação por forma (glifo) + rótulo, nunca só cor — e nunca vermelho. */
const MAPA: Record<
  StatusAlimento,
  { classe: string; glifo: string; rotulo: string }
> = {
  seguro: { classe: "badge-seguro", glifo: "●", rotulo: "seguro" },
  em_teste: { classe: "badge-teste", glifo: "◐", rotulo: "em teste" },
  recusado: { classe: "badge-recusado", glifo: "◇", rotulo: "recusado" },
  nao_oferecido: { classe: "badge-naooferecido", glifo: "○", rotulo: "não oferecido" },
};

export function StatusBadge({ status }: { status: StatusAlimento }) {
  const m = MAPA[status];
  return (
    <span className={`badge ${m.classe}`}>
      <span className="glifo" aria-hidden>
        {m.glifo}
      </span>
      {m.rotulo}
    </span>
  );
}
